import React, { useEffect, useRef, useState } from "react";
import { DataSet, Network } from "vis-network/standalone";
import NetworkNodeModal from "../HighCharts/NetworkNodeModal";
import isEqual from "react-fast-compare";
import "./NetworkGraph.scss";
import { Button } from "antd";
import ArrowDown from "../../../../assets/NetworkGraph/Arrow_Down.svg";
import ArrowLeft from "../../../../assets/NetworkGraph/Arrow_Left.svg";
import ArrowRight from "../../../../assets/NetworkGraph/Arrow_Right.svg";
import Arrow_Up from "../../../../assets/NetworkGraph/Arrow_Up.svg";
import Image from "antd/lib/image";
import fullScreen from "../../../../assets/NetworkGraph/Screen_Full.png";
const NetworkGraph = ({ nodes, edges, options, id, style, single }) => {
  const containerRef = useRef(null);
  const [dataProcessing, setDataProcessing] = useState(true);
  const [postCardDetails, setPostCardDetails] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [screenLoader, setScreenLoader] = useState(true);

  const getNodeOfNetwork = (seriesData, nodeId) => {
    let node;
    let splittedValue = nodeId?.split("$N$");
    if (seriesData && Array.isArray(seriesData)) {
      for (
        let series_index = 0;
        series_index < seriesData?.length;
        series_index++
      ) {
        let series = seriesData?.[series_index];
        if (
          splittedValue?.[0] === id &&
          parseInt(splittedValue?.[1]) === series_index
        ) {
          if (series?.nodes?.[splittedValue?.[2]]) {
            node = series?.nodes?.[splittedValue?.[2]];
            break;
          }
        }
      }
    } else if (seriesData && seriesData?.nodes) {
      if (seriesData?.nodes?.[splittedValue?.[2]]) {
        node = seriesData?.nodes?.[splittedValue?.[2]];
      }
    }
    return node;
  };
  useEffect(() => {
    const container = document.getElementById(id);
    const data = {
      nodes: new DataSet(nodes),
      edges: new DataSet(edges),
    };

    const network = new Network(container, data, options);
    // on init
    network.on("initRedraw", function () {
      // do something like move some custom elements?
      setDataProcessing(true);
    });

    // Add event listener to show tooltip on hover
    network?.on("hoverNode", (event) => {
      // const nodeId = event?.node;
      // console.log("event : ", event, nodeId);
      // const node =
      //   nodes && Array.isArray(nodes) && nodes?.find((f) => f?.id === nodeId);
      // console.log("node : ", node);
    });

    // Add event listener to hide tooltip on mouseout

    network?.on("blurNode", () => {});
    network.on("afterDrawing", function (ctx) {
      setDataProcessing(false);
      setScreenLoader(false);
    });

    //
    network.on("click", function (params) {
      if (params?.nodes?.length > 0) {
        let nodeId = params?.nodes[0];
        const node = getNodeOfNetwork(single, nodeId);
        if (node) {
          setPostCardDetails(node);
        }
      }
    });

    // Clean up when component unmounts
    return () => {
      if (network) {
        network?.destroy();
        network?.off("hoverNode");
        network?.off("blurNode");
        network?.off("initRedraw");
        network?.off("afterDrawing");
        network?.off("click");
      }
    };
  }, [nodes, edges, options]);
  const handleFullScreen = () => {
    const container = containerRef?.current;
    if (container?.requestFullscreen) {
      container?.requestFullscreen();
    } else if (container?.mozRequestFullScreen) {
      container?.mozRequestFullScreen();
    } else if (container?.webkitRequestFullscreen) {
      container?.webkitRequestFullscreen();
    } else if (container?.msRequestFullscreen) {
      container?.msRequestFullscreen();
    }
  };
  return (
    <>
      {screenLoader ? (
        <div className="Network__Graph w-100 h-100">
          <div
            id={id}
            style={{
              width: style?.width ? style?.width : "100%",
              height: style?.height
                ? style?.height?.includes("px")
                  ? style?.height
                  : style?.height + "px"
                : "45rem",
            }}
          ></div>
          <div
            style={{
              marginTop: style?.height
                ? style?.height?.includes("px")
                  ? style?.height
                  : -style?.height + "px"
                : "-45rem",
              height: style?.height
                ? style?.height?.includes("px")
                  ? style?.height
                  : style?.height + "px"
                : "45rem",
            }}
          >
            <div className="loader text-center w-100 h-100">
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="Network__Graph w-100 h-100">
          <div
            id={id}
            ref={containerRef}
            style={{
              width: style?.width ? style?.width : "100%",
              height: style?.height
                ? style?.height?.includes("px")
                  ? style?.height
                  : style?.height + "px"
                : "45rem",
            }}
          ></div>

          {/* <Button
            onClick={handleFullScreen}
            className="fullScreen--btn btn_Clear m-1"
          >
            Full Screen
          </Button> */}
          {postCardDetails && (
            <>
              <NetworkNodeModal
                modalData={postCardDetails}
                isModalOpen={postCardDetails ? true : false}
                setIsModalOpen={setIsModalOpen}
                setIsModalData={setPostCardDetails}
                isVisNetworkGraph={true}
                isModalLoader={isModalLoader}
                setIsModalLoader={setIsModalLoader}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default React?.memo(NetworkGraph, isEqual);
